module.exports = {"stepComponents":{"priceInputCU":{"component":{"props":[{},{"columnElements":[{"columnProps":[{},{},{"hidden":true},{},{},{"hidden":true}]}]}]}},"priceAdvancedInputCU":{"component":{"props":[{},{"columnElements":[{"columnProps":[{},{},{"hidden":true},{},{},{"hidden":true}]}]}]}}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/car/cu/package.car-tjm.json
// module id = 708
// module chunks = 0